import { ASYNC_ROUTERS, CONST_ROUTERS } from '@/const/common';

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */

/**
 * Filter asynchronous routing tables by recursion
 * @param permissions
 */
export function setAsyncRoutes(permissions) {
  const res = [];
  // console.log(permissions)
  permissions.forEach(item => {
    let temp = {
      path: null,
      component: null
    };
    if (item.type === 0) {
      temp.path = item.fullPath;
      temp.component = () => import(item.fillPath);
      if (item.children) {
        temp.redirect = '/';
      }
      res.push(temp);
    }
  });
  return res;
}

const state = {
  routes: [],
  addRoutes: []
};

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = CONST_ROUTERS.concat(routes);
  }
};

const actions = {
  generateRoutes({ commit }, userInfo) {
    return new Promise(resolve => {
      let accessedRoutes;
      if (userInfo.roles.includes('admin')) {
        accessedRoutes = ASYNC_ROUTERS || [];
      } else {
        accessedRoutes = setAsyncRoutes(userInfo.permissions);
      }
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
